import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "/" }) {
  const fullTitle = title ? `${title} · Empire Serv, Inc.` : "Empire Serv, Inc. · Facilities Maintenance & Commercial Cleaning";
  const desc = description || "Empire Serv delivers contract-ready commercial cleaning and facilities maintenance for medical, industrial, and government clients. ISO 9001 · CIMS-GB · GBAC STAR™.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <link rel="canonical" href={`https://empireserv.com${path}`} />
    </Helmet>
  );
}
